import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import TFBar from '../../Charts/Bar';


const Sources = ( { aid, meta, user, viewing, canExport, opps, loans, start, end, purpose } ) => {
    const [ colsSource, setColsSource ] = useState( [] );
    const [ leads, setLeads ] = useState( { id: 'leads' } );
    const [ apps, setApps ] = useState( { id: 'apps' } );
    const [ pas, setPAs ] = useState( { id: 'pas' } );
    const [ locks, setLocks ] = useState( { id: 'locks' } );
    const [ funded, setFunded ] = useState( { id: 'funded' } );
    const [ rows, setRows ] = useState( [] );
    const [ sourceChartData, setSourceChartData ] = useState( [ { name: 'Loading...', values: [ 0, 0, 0 ] } ] );
    const [ scdType, setSCDType ] = useState( '' );
    const [ scdDisplay, setSCDDisplay ] = useState( '' );
    const [ milestoneChartData, setMilestoneChartDate ] = useState( [] );
    const [ mcdType, setMCDType ] = useState( 'Leads' );


    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center w-100'>
                        <Col></Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    useEffect( () => {
        console.log( 'lp: ' + purpose );
    }, [ purpose ] );

    useEffect( () => {
        if ( meta?.global?.picklist?.source ) {
            let cols = [ { field: 'milestone', headerName: '', flex: 1, minWidth: 100, cellClassName: 'tf-metrics-grid-row-label' } ];
            meta.global.picklist.source.forEach( s => {
                cols.push( {
                    field: s.reportLabel,
                    headerName: s.reportLabel,
                    flex: 1,
                    minWidth: 85
                } );
            } );
            cols.push( { field: 'total', headerName: 'Total', flex: 1, minWidth: 75, cellClassName: 'tf-metrics-grid-total' } );
            setColsSource( cols );

            const s = meta.global.picklist.source.find( f => f.default );
            if ( s ) {
                setSCDType( s.reportLabel );
                setSCDDisplay( s.label );
            }
        }
    }, [ meta ] );

    useEffect( () => {
        setRows( [ leads, apps, pas, locks, funded ] );
    }, [ leads, apps, pas, locks, funded ] );

    useEffect( () => {
        const list = [];
        console.log( 'scdType: ' + scdType );
        list.push( { name: 'Leads', amt: leads[scdType] } );
        list.push( { name: 'Apps', amt: apps[scdType] } );
        list.push( { name: 'PAs', amt: pas[scdType] } );
        list.push( { name: 'Locks', amt: locks[scdType] } );
        list.push( { name: 'Funded', amt: funded[scdType] } );
        setSourceChartData( list );
        // console.log( list );
    }, [ leads, apps, pas, locks, funded, scdType ] );

    useEffect( () => {
        setRows( [ leads, apps, pas, locks, funded ] );
    }, [ leads, apps, pas, locks, funded, mcdType ] );

    useEffect( () => {
        let row = { id: 'leads', milestone: 'Leads', total: 0 };
        meta.global.picklist.source.forEach( s => row[s.reportLabel] = 0 );
        
        if ( opps ) {
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );

            Object.keys( opps ).forEach( loid => {
                const lo = opps[loid];
                if ( !viewing.includes( lo.aid ) ) {
                    return;
                }

                // console.log( 'opp: ', lo );
                if ( lo.oppDate ) {
                    const od = new Date( lo.oppDate + 'T12:00:00.000' );
                    if ( od.getTime() >= sd.getTime() && od.getTime() <= ed.getTime() ) {
                        if ( purpose === '*' || purpose === lo.purpose ) {
                            const s = meta.global.picklist.source.find( f => f.label === lo.source );
                            const lab = ( s?.reportLabel ) ? s.reportLabel : 'OTHER';
                            row[lab]++;
                            row.total++;
                        }
                    }
                }
            } );
        }

        setLeads( row );
    }, [ opps, start, end, purpose, meta.global.picklist.source, viewing ] );

    useEffect( () => {
        let apps = { id: 'apps', milestone: 'Apps', total: 0 };
        let pas = { id: 'pas', milestone: 'PAs', total: 0 };
        let locks = { id: 'locks', milestone: 'Locks', total: 0 };
        let funded = { id: 'funded', milestone: 'Funded', total: 0 };

        meta.global.picklist.source.forEach( s => {
            apps[s.reportLabel] = 0;
            pas[s.reportLabel] = 0;
            locks[s.reportLabel] = 0;
            funded[s.reportLabel] = 0;
        } );

        if ( loans ) {
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );

            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( !viewing.includes( l.aid ) ) {
                    return;
                }

                if ( purpose !== '*' && purpose !== l.purpose ) {
                    return;
                }

                // App
                if ( l.appCompletedDate ) {
                    const acd = new Date( l.appCompletedDate );
                    acd.setHours( 12, 0, 0, 0 );
                    if ( acd.getTime() >= sd.getTime() && acd.getTime() <= ed.getTime() ) {
                        const s = meta.global.picklist.source.find( f => f.label === l.source );
                        apps[ s?.reportLabel ? s.reportLabel : 'OTHER' ]++;
                        apps.total++;
                    }
                }

                // PA
                if ( l.paDate ) {
                    const pad = new Date( l.paDate + 'T12:00:00.000' );
                    if ( pad.getTime() >= sd.getTime() && pad.getTime() <= ed.getTime() ) {
                        const s = meta.global.picklist.source.find( f => f.label === l.source );
                        if ( !s ) {
                            console.log( l.lid + ' - ' + l.source );
                        }
                        pas[ s?.reportLabel ? s.reportLabel : 'OTHER' ]++;
                        pas.total++;
                    }
                }

                // Locks
                if ( l.rateLockDate ) {
                    const rld = new Date( l.rateLockDate + 'T12:00:00.000' );
                    if ( rld.getTime() >= sd.getTime() && rld.getTime() <= ed.getTime() ) {
                        const s = meta.global.picklist.source.find( f => f.label === l.source );
                        locks[ s?.reportLabel ? s.reportLabel : 'OTHER' ]++;
                        locks.total++;
                    }
                }

                // Funded
                if ( l.fundedDate ) {
                    const fd = new Date( l.fundedDate + 'T12:00:00.000' );
                    if ( fd.getTime() >= sd.getTime() && fd.getTime() <= ed.getTime() ) {
                        const s = meta.global.picklist.source.find( f => f.label === l.source );
                        funded[ s?.reportLabel ? s.reportLabel : 'OTHER' ]++;
                        funded.total++;
                    }
                }
            } );
        }

        setApps( apps );
        setPAs( pas );
        setLocks( locks );
        setFunded( funded );
    }, [ loans, start, end, purpose, meta.global.picklist.source, viewing ] );

    return (
        <Container fluid>
            <Row>
                <Col className='px-5' xs={6}>
                    <Row>
                        <Col>{scdDisplay} Business</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TFBar data={sourceChartData} h={225} />
                        </Col>
                    </Row>
                </Col>
                <Col className='px-5' xs={6}>
                    <TFBar data={sourceChartData} h={225} />
                </Col>
            </Row>
            <Row>
                <Col className='p-0'>
                    <DataGridPro
                        rows={ rows }
                        columns={ colsSource }
                        disableSelectionOnClick
                        hideFooter={ true }
                        autoHeight={ true }
                        rowHeight={ 40 }
                        slots={ { toolbar: toolbar } }
                    />
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    opps: state.leadopps.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Sources );